import { Layer, Source } from '@vis.gl/react-maplibre';
import type { Polygon } from 'geojson';
import { Fragment } from 'react';

import stateGeometry from '@/data/state-polygon.json';
import { useMapStore } from '@/stores/useMapStore';

export function MaskingLayer() {
  const polygons = (stateGeometry as Polygon).coordinates;
  const style = useMapStore((state) => state.style);

  return (
    <Fragment>
      <Source
        id="hessen"
        type="geojson"
        data={{
          type: 'Polygon',
          coordinates: [
            [
              [180, 90],
              [-180, 90],
              [-180, -90],
              [180, -90],
              [180, 90],
            ],
            ...polygons,
          ],
        }}
      />
      <Layer
        id="ADMIN_LEVELS_LAYER"
        source="hessen"
        type="fill"
        paint={{
          'fill-opacity': style === 'BASIC' ? 0.125 : 0.425,
          'fill-color': 'black',
        }}
      />
    </Fragment>
  );
}
